/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiMenuDots3VIcon16Regular = forwardRef('UiMenuDots3VIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.248 2.998a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M9.248 8a1.248 1.248 0 1 1-2.496 0 1.248 1.248 0 0 1 2.496 0Z" }),
        React.createElement("path", { d: "M8 14.25a1.248 1.248 0 1 0 0-2.497 1.248 1.248 0 0 0 0 2.497Z" })));
});
